module.exports = __webpack_public_path__ + "static/media/agilite-logo.86510d6a.ico";